import { useMutation } from '@tanstack/react-query';
import { rejectAgreement, signAgreement } from './api';

export const useSignAgreementMutation = () =>
  useMutation({ mutationFn: signAgreement });

export const useRejectAgreementMutation = () =>
  useMutation({ mutationFn: rejectAgreement });
